import { http } from "api/http";

const saveToken = (data: any) => {
  return http.post("/notifications/token", data);
};

const getNotifications = ({ queryKey }) => {
  return http.get("/notifications", {
    params: {
      ...queryKey[1],
    },
  });
};

const updateNotifications = (data) => {
  return http.patch("/notifications/update", data);
};

const getNotificationsCount = () => {
  return http.get("/notifications/count");
};

const getNotificationsReminder =({queryKey})=>{
  return http.get("/notifications/notificationReminder", { params: { ...queryKey[1] } })
}
const sendReminderNotification =(data: any)=>{
   return http.post("/notifications/sendReminderNotification", data);
 
}
const getMailReminderSent =(data: any)=>{
   return http.get("/notifications/mailReminderSent", data);
 
}


export { saveToken, getNotifications, updateNotifications, getNotificationsCount,getNotificationsReminder,sendReminderNotification,getMailReminderSent };
